export default "<div class=\"occasions\">\n    <slot name=\"occasions\"></slot>\n</div>\n<slot name=\"button\"></slot>";


//////////////////
// WEBPACK FOOTER
// ./scripts/web-components/occasions-overview/template.html
// module id = 300
// module chunks = 0